import React from 'react';
import { motion } from 'framer-motion';
export function ProblemSection() {
  return <section className="py-16 md:py-24 px-5 md:px-8 bg-[#0d1222] border-y border-[#1a1f3a]" data-id="element-93">
      <div className="max-w-5xl mx-auto" data-id="element-94">
        <div className="flex flex-col md:flex-row items-center gap-10 md:gap-16" data-id="element-95">
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.6
        }} className="md:w-1/2" data-id="element-96">
            <img src="https://cdn.magicpatterns.com/uploads/5wQd4uXp1G7dUMHMjTMMsx/Gemini_Generated_Image_1gvixi1gvixi1gvi.jpg" alt="Mujer sufriendo de tinnitus en la noche" className="w-full h-auto rounded-xl shadow-2xl border border-[#2a3150] grayscale-[20%]" data-id="element-97" />
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.6
        }} className="md:w-1/2 space-y-6 text-gray-300 text-lg leading-relaxed" data-id="element-98">
            <p className="font-serif text-2xl text-white italic" data-id="element-99">
              Son las 11:00 PM. Apagas la luz, intentas cerrar los ojos y ahí
              está de nuevo.
            </p>

            <p data-id="element-100">
              Ese pitido agudo, ese siseo constante o ese rugido que parece
              gritar más fuerte cuanto más intentas ignorarlo.
            </p>

            <p data-id="element-101">
              Mientras el resto del mundo descansa en un silencio reparador,
              para ti el silencio se ha convertido en una cámara de tortura. Te
              das la vuelta, ajustas la almohada y sientes cómo la desesperación
              crece en tu pecho.{' '}
              <span className="text-[#d4a853]" data-id="element-102">"¿Será así para siempre?"</span>,
              te preguntas mientras el reloj marca las 2:00 AM.
            </p>

            <div className="bg-[#1a1f3a] p-6 rounded-lg border-l-4 border-[#d4a853] mt-8" data-id="element-103">
              <h3 className="font-serif text-xl text-white mb-3 font-bold" data-id="element-104">
                El verdadero problema:
              </h3>
              <p className="text-base" data-id="element-105">
                El problema no es solo el ruido en tus oídos. El problema es que
                tu cerebro ha entrado en un estado de "alerta de supervivencia".
                Cada vez que escuchas el zumbido, tu sistema nervioso dispara
                cortisol y adrenalina, manteniéndote en un estado de lucha o
                huida que hace que dormir sea biológicamente imposible.
              </p>
            </div>

            <p data-id="element-106">
              Has intentado ignorarlo, pero el esfuerzo solo lo hace más
              presente. Has probado tapones de oídos, pero al bloquear el mundo
              exterior, el zumbido interno suena diez veces más fuerte. Estás
              agotado, irritable y temes el momento en que llega la noche porque
              sabes que la batalla comienza de nuevo.
            </p>
          </motion.div>
        </div>
      </div>
    </section>;
}